module.exports = __webpack_public_path__ + "img/visa.2339f283.svg";